import { MissionData } from '../blocks/mission'
import template from './templates/RJF11.rbxl'
import thumbnail1 from './thumbnails/RJF11/SpawnLocation.png'
import thumbnail2 from './thumbnails/RJF11/UFO.png'
import thumbnail3 from './thumbnails/RJF11/YellowBall.png'
import thumbnail4 from './thumbnails/RJF11/RedBall.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①スタートちてん',
      thumbnail: thumbnail1,
    },
    {
      name: '②UFO',
      thumbnail: thumbnail2,
    },
    {
      name: '③きいろいボール',
      thumbnail: thumbnail3,
    },
    {
      name: '④あかいボール',
      thumbnail: thumbnail4,
    },
  ],
}

export default mission
